import axios from 'axios';

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        // 419: CSRF token is stale (session expired). Any GET refreshes the XSRF-TOKEN cookie,
        // then the request is retried once (docs/app/SPEC.md, decision 11).
        const config = error.config;
        if (error.response?.status === 419 && config && !config._csrfRetried) {
            config._csrfRetried = true;
            delete config.headers?.['X-XSRF-TOKEN'];
            try {
                await axios.get('/auth/me');
            } catch {
                // 401 for a guest still refreshes the cookie
            }
            return axios(config);
        }

        // 423: the session is locked on the server, the lock screen goes up (docs/pwa/SPEC.md).
        if (error.response?.status === 423 && error.response.data?.lock) {
            window.dispatchEvent(new CustomEvent('app:locked', { detail: error.response.data.lock }));
        }

        if (error.response?.status === 401) {
            const url = error.config?.url ?? '';
            const base = error.config?.baseURL ?? '';
            const full = `${base}${url}`;
            // Initial “am I logged in?” check — not a session expiry.
            // 5 wrong PINs sign out too, but the lock screen shows its own message for that.
            if (!full.includes('/auth/me') && error.response.data?.reason !== 'pin_attempts') {
                window.dispatchEvent(new CustomEvent('auth:session-ended'));
            }
        }
        return Promise.reject(error);
    }
);

window.axios = axios;

window.axios.defaults.baseURL = '/app';
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
